import React from 'react';
import {useTranslation} from 'react-i18next';
import {AI_AGENT_MEDIA} from '../../constants';
import AiAgentMedia from '../aiAgentMedia/AiAgentMedia';
import * as css from './AiAgentFab.css';

interface AiAgentFabProps {
    onClick: () => void;
}

function AiAgentFab({onClick}: AiAgentFabProps) {
    const {t} = useTranslation('aiAgent');

    return (
        <css.fab
            type="button"
            onClick={onClick}
            aria-label={t('title')}
            aria-haspopup="dialog"
            data-cy="account-ai-agent-fab"
        >
            <AiAgentMedia src={AI_AGENT_MEDIA.fab.src} poster={AI_AGENT_MEDIA.fab.poster} />
        </css.fab>
    );
}

export default AiAgentFab;
